export const hrProFreeMonthOfferKey = 'hr-pro-free-month';

export interface AddonOfferEligibility {
  claimable: boolean;
}
